import {
  BulkExport,
  ExportFormats,
  ExportPayload,
} from '@qualio/export-components';
import { PageOrientation, QualioDocument } from './model/document';

type ExportDataItem = BulkExport['data'][number];
// This is a workaround check the type is correct
const createExportDataItem = (item: ExportDataItem): ExportDataItem => item;

type ExportDocumentsQueryParams = {
  coverPageEnabled: boolean;
  controlledStatus: 'controlled' | 'uncontrolled';
  shouldShowShrinkingOption: boolean;
  contentShrinkingEnabled: boolean;
  includeChangeControl: boolean;
  includeDocx: boolean;
  pageOrientation?: PageOrientation;
  enablePaginationExportStyles?: boolean;
};

export const buildExportDocumentsPayload = (
  documents: QualioDocument[],
  companyId: number,
  isBulkExport: boolean,
  queryParams: ExportDocumentsQueryParams,
): ExportPayload => {
  const {
    coverPageEnabled,
    controlledStatus,
    shouldShowShrinkingOption,
    contentShrinkingEnabled,
    includeChangeControl,
    includeDocx,
    pageOrientation,
    enablePaginationExportStyles,
  } = queryParams;

  const medtechApiUrl = process.env.REACT_APP_MEDTECH_API_URL;

  return {
    exports: [
      {
        format: ExportFormats.bulk,
        data: documents.flatMap(({ id, code, title, document_matrix_id }) => {
          const docMatrixIdParam = document_matrix_id
            ? `document_matrix_id=${document_matrix_id}&`
            : '';
          const docIdParam = typeof id === 'number' ? `document_id=${id}&` : '';
          return [
            createExportDataItem({
              bundle_path: includeChangeControl
                ? `${code} ${title}`
                : undefined,
              resource_description: `Document ${code}`,
              export_payload: `${medtechApiUrl}/v3/${companyId}/documents/export-payload?${docMatrixIdParam}${docIdParam}include_cover_page=${coverPageEnabled}&controlled_status=${controlledStatus}&include_docx=${includeDocx}${
                shouldShowShrinkingOption
                  ? `&shrink_content=${contentShrinkingEnabled}`
                  : ''
              }${
                pageOrientation ? `&page_orientation=${pageOrientation}` : ''
              }${
                enablePaginationExportStyles
                  ? '&enable_pagination_export_styles=true'
                  : ''
              }`,
              include_docx: includeDocx,
            } as ExportDataItem),
            includeChangeControl
              ? createExportDataItem({
                  bundle_path: `${code} ${title}`,
                  export_payload: `${medtechApiUrl}/v2/${companyId}/change_management/change_controls/change_items/export_payload?item_id=${id}&item_type=document`,
                  ignore_errors: ['change_control_not_found'],
                  resource_description: `CC for document ${code}`,
                  include_docx: includeDocx,
                } as ExportDataItem)
              : undefined,
          ].filter(Boolean) as BulkExport['data'];
        }),
      },
    ],
    metadata: {
      domain: 'documents',
      resource_name: isBulkExport
        ? 'Bulk document export'
        : `${documents[0].code} ${documents[0].title} export`,
      send_notification: isBulkExport,
    },
  };
};
